import { IApiResponse } from "../../../@types/api-response.type";
import { IConfiguration } from "../../../@types/configuration.type";
import { Api } from "../ApiConfig";
import { ApiException } from "../ApiException";
import { getErrorMessage } from "../../../utils/utils";

export const searchConfigurationsByKeys = async (keys: string[]) : Promise<IApiResponse<IConfiguration[]> | ApiException> => {
    try {
        const { data } = await Api.post<IApiResponse<IConfiguration[]>>(`/api/Configuration/SearchConfigurationsByKeys`, keys);
        return data
    } catch (error) {
        throw new ApiException(getErrorMessage(error, 'Erro ao buscar as configurações'))
    }
}

export const addOrUpdateConfigurations = async (configurations: IConfiguration[]) : Promise<IApiResponse<void> | ApiException> => {
    try {
        const { data } = await Api.post<IApiResponse<void>>(`/api/Configuration/AddOrUpdateConfigurations`, configurations);
        return data
    } catch (error) {
        throw new ApiException(getErrorMessage(error, 'Erro ao buscar as configurações'))
    }
}